import React from "react";
import ReactDOM from "react-dom/client";
import KeyxLanding from "./components/KeyxLanding";
import "./styles/styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<KeyxLanding />);
